import React, {Component} from 'react';
import {connect} from 'react-redux';
import Loader from "react-loader-spinner";
import {toastMessage} from '../utils/toast';
import * as formActions from '../../Redux/Actions/form';
import * as jobsActions from '../../Redux/Actions/jobs';
import * as userAuthActions from '../../Redux/Actions/user';
import {Button} from '../Ui/Button';
import {Input, TextArea} from '../Ui/Input';
import Radio from '../Ui/Radio';
import DropDown from '../Ui/DropDown';
import Upload from '../Ui/Upload';
import Checkbox from '../Ui/Checkbox';
import Map from '../Ui/Map';
import { DisplayServiceCard } from '../CreateForm/ServiceCard/displayServiceCard';
import { DocumentVaultModal, DocumentUploadModal } from './documentModal';
import { MapModal } from './mapModal';
import { ContainerOuter, LoaderContainer, ContainerInner, DataContainer } from './styles';
import { formValidation } from '../utils/formValidation';
import {getParams} from '../utils';
import AamerLoader from '../Ui/Loader';
import { FiInfo } from "react-icons/fi";
import CONFIG from '../../config';

class PreviewForm extends Component{

    state = {
        data: {},
        formID: '',
        fieldsData: [],
        documentVaultLabel: '',
        documentVaultData: [],
        documentVaultModal: false,
        documentVaultModalLoading: false,
        documentFromVault: false,
        documentUploadModal: false,
        documentUploadLoading: false,
        documentUploadData: {},
        mapValueLabel: '',
        mapModal: false,
        mapModalLoading: false,
        params: {},
        buttonLoadingsubmit: false,
        buttonLoadingsaveasdraft: false
    };

    componentDidMount(){
        const {formID} = this.props.match.params;
        let params = getParams(window.location.search);
        this.getIndividualForm(formID, params);
        this.setState({ formID, params });
    }

    getIndividualForm = (formID, params) => {
        this.setState({loading: true});
        const { history, userAuthLogout } = this.props;
        formActions.getIndividualForm(formID).then(res => {
            if(CONFIG.isSlackBotEnable === true){
                let text = `name: Form Started\ntime:${Date()}\nuserID:${params.userID}\nformId:${formID}\nfieldName:\ntimeDifference:`;
                let payload = {text: text};
                formActions.slackBOT(payload).then();
            }

            if(res && res.data){
                this.setState({
                    data: res.data && res.data[0],
                    fieldsData: res.data && JSON.parse(res.data[0].json)
                });
            }else{
                toastMessage('error', 'Unable to load the form');
            }
            this.setState({loading: false});
        }).catch(err => {
            toastMessage('error', 'Unable to load the form');
            if(err.response.status === 401) {
                userAuthLogout();
                localStorage.removeItem('jwt');
                history.push('/');
            }
        });
    }

    handleInputChange = (key, value) => {
        let keyName = key.replace(/ /g, '').toLowerCase();
        this.setState({
            [keyName]: value,
            [keyName+'Err']: ''
        });
        (keyName === 'userinfo') && this.handleCheckedDefaultUserInfo(value);
    }

    handleCheckedDefaultUserInfo = (value) => {
        let defaultuserinfoemail = '', defaultuserinfophonenumber = '';
        const { params } = this.state;
        if (value) {
            defaultuserinfoemail = params.email;
            defaultuserinfophonenumber = params.phonenumber;
        }
        this.setState({
            defaultuserinfoemail, defaultuserinfophonenumber
        });
    }

    handleMultiCheckbox = (label, key) => {
        let oldData = this.state[label] ? this.state[label] : [];
        this.setState({
            [label]: oldData.includes(key) ? oldData.filter(value => value !== key) : [...oldData, key]
        });
    }

    handleUploadModal = (name, files, category, limit) => {
        if(isNaN(limit) || (files.length <= limit)){
            this.setState({
                documentUploadData: {label: name.replace(/ /g, '').toLowerCase(), files, category, limit},
                documentUploadModal: true,
                [name+'Err']: ''
            });
        }else{
            this.setState({[name+'Err']: `You can select upto ${limit} files only`});
        }
    }

    handleUploadDocument = (modalData) => {
        let fID = this.props.match.params;
        const { documentUploadData, params } = this.state;
        const { history, userAuthLogout } = this.props;
        this.setState({ documentUploadLoading: true });

        let uploadStartTime = new Date();
        if(CONFIG.isSlackBotEnable === true){
            let uploadStartText = `name: Upload file start\ntime:${uploadStartTime}\nuserID:${params.userID}\nformID:${fID.formID}\nfieldName:${documentUploadData.label}\ndocumentIDs:\ntimeDifference:`;
            let payload = {text: uploadStartText};
            formActions.slackBOT(payload).then();
        }
        
        let data = new FormData();
        data.append('userId', params.userID);
        documentUploadData.category && documentUploadData.category.value && data.append('tag', documentUploadData.category.value);
        for(let i=0; i <= documentUploadData.files.length; i++) {
            if(modalData['name'+(i+1)] !== undefined) {
                data.append('files', documentUploadData.files[i]);
                data.append('fileNames', modalData['name'+(i+1)] + '.' + modalData['extension'+(i+1)]);
                data.append('extensions', '.' + modalData['extension'+(i+1)]);
            }
        }
        
        let keyName = documentUploadData.label;
        formActions.uploadMultipleDocument(data).then(res => {
            if(res && res.data){
                if(CONFIG.isSlackBotEnable === true){
                    let uploadEndTime = new Date();
                    let timeDif = (uploadEndTime.getTime() - uploadStartTime.getTime())/1000;
                    let uploadEndText = `name: Upload file end\ntime:${Date()}\nuserID:${params.userID}\nformID:${fID.formID}\nfieldName:${documentUploadData.label}\ndocumentIDs:${res.data}\ntimeDifference:${timeDif} s`;
                    let payload = {text: uploadEndText};
                    formActions.slackBOT(payload).then();
                }
                
                this.setState({
                    documentUploadModal: false,
                    documentFromVault: false,
                    documentUploadLoading: false,
                    [keyName]: res.data,
                    [keyName+'Err']: '',
                    [keyName+'Name']: (documentUploadData.files.length === 1) ? modalData['name1'] : `${documentUploadData.files.length} files selected`
                });
            } else {
                this.setState({
                    documentUploadModal: false,
                    documentFromVault: false,
                    documentUploadLoading: false
                });
                toastMessage('error', (res && res.message));
            }
        }).catch(err => {
            this.setState({
                documentUploadModal: false,
                documentFromVault: false,
                documentUploadLoading: false
            });
            toastMessage('error', 'Unable to upload the documents');
            if(err.response.status === 401) {
                userAuthLogout();
                localStorage.removeItem('jwt');
                history.push('/');
            }
        });
    }

    handleDocumentVault = (name) => {
        this.setState({documentVaultModal: true, documentVaultModalLoading: true, [name+'Err']: ''});
        const { history, userAuthLogout } = this.props;
        const { params } = this.state;
        let keyName = name.replace(/ /g, '').toLowerCase();
        formActions.listUserDocuments(params.userID).then(res => {
            if(res && res.data){
                this.setState({documentVaultModalLoading: false, documentVaultData: res.data, documentVaultLabel: keyName, [keyName+'Err']: ''});
            }
        }).catch(err => {
            toastMessage('error', 'Unable to load the documents');
            if(err.response.status === 401) {
                userAuthLogout();
                localStorage.removeItem('jwt');
                history.push('/');
            }
        });
    }

    handleReloadDocumentVault = () => {
        this.setState({documentVaultModal: true, documentVaultModalLoading: true});
        const { params } = this.state;
        const { history, userAuthLogout } = this.props;
        formActions.listUserDocuments(params.userID).then(res => {
            if(res && res.data){
                this.setState({ documentVaultModalLoading: false, documentVaultData: res.data });
            }
        }).catch(err => {
            toastMessage('error', 'Unable to load the documents');
            if(err.response.status === 401) {
                userAuthLogout();
                localStorage.removeItem('jwt');
                history.push('/');
            }
        });
    }

    handleDocumentID = (documentId, fileName) => {
        const {documentVaultLabel} = this.state;
        this.setState({documentVaultModal: false, [documentVaultLabel]: [documentId], [documentVaultLabel+'Name']: fileName, documentFromVault: true});
    }

    handleRemoveDocument = (name) => {
        const { params } = this.state;
        formActions.removeDocument(params.userID, this.state[name]).then(res => {
            this.setState({ [name+'Name']: '', [name]: '', documentUploadData: {} });
            toastMessage('success', (res && res.message) || `Successfully deleted the document`);
        }).catch(err => {
            console.log('Something Went Wrong', err);
        });
    }

    handleLoadMap = (name) => {
        this.setState({mapModal: true, mapModalLoading: true, [name+'Err']: '', mapValueLabel: name.replace(/ /g, '').toLowerCase()});
    }

    handleSetCoordinates = (value) => {
        const {mapValueLabel} = this.state;
        this.setState({
            mapModal: false,
            [mapValueLabel]: value
        });
    }

    handleMapValueChange = (value, name) => {
        let keyName = name.replace(/ /g, '').toLowerCase();
        this.setState({
            [keyName]: {...this.state[keyName], address: value}
        });
    }

    handleSubmit = (actionLabel) => {
        console.log(actionLabel);
        const { history, userAuthLogout } = this.props;
        let { fieldsData, formID, params } = this.state;
        fieldsData = fieldsData.formFields && fieldsData.formFields.map(({name, type, englishlabel, arabiclabel, required}) => ({type, englishlabel, arabiclabel, required, name: name ? name.replace(/ /g, '').toLowerCase() : ''}));
        let data = {}, documents = {}, errCount = 0;
        if (actionLabel === 'saveasdraft') {
            this.setState({ ['buttonLoading'+actionLabel]: true });
            for (const field of fieldsData) {
                if(field.type === 'upload') {
                    documents = {...documents, [field.englishlabel+'+'+field.name]: this.state[field.name]};
                    this.setState({[field.name+'Err']: ''})
                } else {
                    data = {...data, [field.englishlabel+'+'+field.name]: this.state[field.name]};
                }
            }
        } else { 
            for (const field of fieldsData) {
                const response = formValidation(field.type, field.englishlabel, field.required, this.state[field.name]);
                errCount = response ? ++errCount : errCount;
                if(response){
                    console.log(response);
                    // response && this.setState({ ['buttonLoading'+actionLabel]: false });
                    this.setState({[field.name+'Err']: response})
                }else if(errCount === 0) {
                    if(field.type === 'upload') {
                        documents = {...documents, [field.englishlabel+'+'+field.name]: this.state[field.name]};
                        this.setState({[field.name+'Err']: ''})
                    } else {
                        data = {...data, [field.englishlabel+'+'+field.name]: this.state[field.name]};
                    }
                }
            }
        }
        if(errCount === 0) {
            let jobId;
            if(params.jobId === undefined || params.jobId === null || params.jobId === ''){
                jobId = 0;
            }
            else{
                jobId = params.jobId;
            }
            let payload = {
                fromUserId: params.userID, 
                processId: params.processID, 
                formId: formID, 
                parentId: jobId,
                json: JSON.stringify({data, documents})
            };
            this.setState({ ['buttonLoading'+actionLabel]: true });
            let apiName = (actionLabel === 'saveasdraft') ? 'saveAsDraft' : 'create';
            jobsActions[apiName](payload).then(res => {
                if(res && res.data){
                    history.push(`/submitted-form/${formID}`);
                }
                this.setState({ ['buttonLoading'+actionLabel]: false });
            }).catch(err => {
                this.setState({ ['buttonLoading' + actionLabel]: false });
                if (err.response && err.response.data?.data?.validations) {
                    const validations = err.response.data?.data?.validations;
                    if (Array.isArray(validations) && validations.length > 0) {
                        const message = validations
                            .map(msg => `${msg.trim()}`)
                            .join('\n');
                        toastMessage('error', message, true, true);
                    } else {
                        toastMessage('error', 'Please fill the required fields', true);
                    }
                } else {
                    toastMessage('error', (err.response && err.response.data.message) || 'Unable to submit the form');
                }
                if(err.response.status === 401) {
                    userAuthLogout();
                    localStorage.removeItem('jwt');
                    history.push('/');
                }
            });
        }
    }

    render(){
        const { data, params, formID, fieldsData, documentVaultModal, documentVaultData, documentFromVault, documentUploadModal, documentUploadData, documentUploadLoading, documentVaultModalLoading,
            mapModal, mapModalLoading, mapValueLabel } = this.state;
        let isArabic = (params.lang === 'ar');

        return(
            <>
                <ContainerOuter style={{webkitUserSelect: 'none', mozUserSelect: 'none', msUserSelect: 'none', userSelect: 'none'}}>
                    {!(data && data.name) ? <LoaderContainer><AamerLoader /></LoaderContainer> : <ContainerInner>
                        {(fieldsData && fieldsData.formFields.length === 0) ? <p style={{textAlign: 'center'}}>No Data Available</p> : 
                            <>
                                <h3 style={{color: '#121180', marginTop: '25px'}} className="text-center pt-16 pb-6">{isArabic ? fieldsData.arabictitle : data.name}</h3>
                                {(fieldsData.serviceCards && fieldsData.serviceCards.length !== 0) && <DisplayServiceCard isArabic={isArabic} data={fieldsData.serviceCards} formID={formID} />}
                                {fieldsData.formFields.map(({type, name, englishlabel, arabiclabel, method, characterlength, required, disabled, label, placeholder, options, multiple, dynamic, encrypt, documentvault, limit, category}, index) => (
                                    <DataContainer key={index} style={{background: 'none'}}>
                                        {(type === 'input') ? <Input isArabic={isArabic} onChange={e => this.handleInputChange(name, e.target.value)} value={this.state[name.replace(/ /g, '').toLowerCase()]} maxLength={characterlength} method={method} encrypt={encrypt} label={englishlabel || label} arabiclabel={arabiclabel} required={required} placeholder={placeholder} error={this.state[name.replace(/ /g, '').toLowerCase()+'Err']} />
                                            : (type === 'date') ? <Input isArabic={isArabic} onChange={e => this.handleInputChange(name, e.target.value)} value={this.state[name.replace(/ /g, '').toLowerCase()]} label={englishlabel || label} arabiclabel={arabiclabel} method={'date'} required={required} placeholder={placeholder} error={this.state[name.replace(/ /g, '').toLowerCase()+'Err']} />
                                                : (type === 'checkbox') ? <Checkbox isArabic={isArabic} label={englishlabel || label} arabiclabel={arabiclabel} disabled={disabled} required={required} options={options} value={this.state[name.replace(/ /g, '').toLowerCase()]} onChange={e => this.handleInputChange(name, e.target.checked)} multiOnChange={this.handleMultiCheckbox} error={this.state[name.replace(/ /g, '').toLowerCase()+'Err']} />
                                                    : (type === 'textarea') ? <TextArea isArabic={isArabic} label={englishlabel || label} arabiclabel={arabiclabel} maxLength={characterlength} value={this.state[name.replace(/ /g, '').toLowerCase()]} method={'text'} required={required} placeholder={placeholder} onChange={e => this.handleInputChange(name, e.target.value)} error={this.state[name.replace(/ /g, '').toLowerCase()+'Err']} />
                                                        : (type === 'radio') ? <Radio isArabic={isArabic} label={englishlabel || label} arabiclabel={arabiclabel} required={required} options={options} dynamic={dynamic} value={this.state[name.replace(/ /g, '').toLowerCase()]} onChange={e => this.handleInputChange(name, e.target.value)} error={this.state[name.replace(/ /g, '').toLowerCase()+'Err']} />
                                                            : (type === 'dropdown') ? <DropDown isArabic={isArabic} label={englishlabel || label} arabiclabel={arabiclabel} required={required} options={options} dynamic={dynamic} placeholder={placeholder} onChange={(value) => this.handleInputChange(name, value.value)} error={this.state[name.replace(/ /g, '').toLowerCase()+'Err']} />
                                                                : (type === 'upload') ? <Upload formID={formID} isArabic={isArabic} label={englishlabel || label} arabiclabel={arabiclabel} required={required} multiple={multiple} placeholder={placeholder} documentvault={documentvault} onChange={e => this.handleUploadModal(name, e.target.files, category, parseInt(limit))} selectedFiles={this.state[name.replace(/ /g, '').toLowerCase()+'Name']}
                                                                        documentFromVault={documentFromVault} listDocument={() => this.handleDocumentVault(name)} handleRemoveDocument={() => this.handleRemoveDocument(name.replace(/ /g, '').toLowerCase())} error={this.state[name.replace(/ /g, '').toLowerCase()+'Err']} />
                                                                    : (type === 'breakline') ? <hr className="section-divider" />
                                                                        : (type === 'disclaimer') ? <span><FiInfo style={{margin: '-5 0 0 0', color: '#121180', fontSize: '20px'}}/> <i>{isArabic? arabiclabel: englishlabel}</i></span>
                                                                            : (type === 'map') ? <Map formID={formID} isArabic={isArabic} label={englishlabel || label} arabiclabel={arabiclabel} required={required} placeholder={placeholder} onClick={e => this.handleLoadMap(name)} value={this.state[name.replace(/ /g, '').toLowerCase()]} error={this.state[name.replace(/ /g, '').toLowerCase()+'Err']} handleMapValueChange={e => this.handleMapValueChange(e.target.value, name)} />
                                                                                : ''}
                                    </DataContainer>
                                ))}
                                {(fieldsData && fieldsData.actions && fieldsData && fieldsData.actions.length !== 0) && <div>
                                    <DataContainer className="m-3 mb-8" style={{margin: '8px 0', display: 'flex', justifyContent: 'center', background: 'none'}}>
                                        {fieldsData.actions.map(({actionLabel, actionName, arabicActionLabel, arabicActionName}) =>
                                            <Button disabled={this.state['buttonLoading'+actionLabel]} key={actionLabel} style={{marginRight: 8}} onClick={() => this.handleSubmit(actionLabel)}>{isArabic ? arabicActionName : actionName}{this.state['buttonLoading'+actionLabel] && <Loader type="Oval" color="#00BFFF" height={15} width={15} style={{marginLeft: '10px'}} />}</Button>
                                        )}
                                    </DataContainer>
                                </div>}
                            </>
                        }
                    </ContainerInner>}
                </ContainerOuter>
                {documentUploadModal && <DocumentUploadModal title={'Upload Document'} showModal={documentUploadModal} loading={documentUploadLoading} data={documentUploadData} handleOk={this.handleUploadDocument} handleCancel={() => this.setState({documentUploadModal: false})} />}
                {documentVaultModal && <DocumentVaultModal title={'Select Document'} showModal={documentVaultModal} loading={documentVaultModalLoading} data={documentVaultData} handleOk={this.handleDocumentID} handleCancel={() => this.setState({documentVaultModal: false})} isArabic={isArabic} userID={params.userID} handleReloadDocumentVault={this.handleReloadDocumentVault} />}
                {mapModal && <MapModal showModal={mapModal} loading={mapModalLoading} value={this.state[mapValueLabel.replace(/ /g, '').toLowerCase()]} handleOk={this.handleSetCoordinates} handleCancel={() => this.setState({mapModal: false})} isArabic={isArabic} userID={params.userID} />}
            </>
        );
    };
};

const mapDispatchToProps = (dispatch) => ({
    userAuthLogout: () => dispatch(userAuthActions.userAuthLogout())
});

export default connect(null, mapDispatchToProps)(PreviewForm);